import React from 'react';
import styles from './Hero.module.css';

const Hero = () => {
  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.heroBackground}>
        <div className={styles.heroOverlay}></div>
      </div>
      
      <div className="container">
        <div className={styles.heroContent}>
          <div className={styles.heroBadge}>
            <span>МОСКВА</span>
          </div>
          
          <h1 className={styles.heroTitle}>
            ОФИЦИАЛЬНЫЕ КАССОВЫЕ ЧЕКИ
            <span className={styles.heroTitleAccent}>С QR-КОДОМ</span>
          </h1>
          
          <p className={styles.heroSubtitle}>
            100% подтверждение через ФНС. Работаем с юридическими и физическими лицами. 
            Конфиденциальность гарантирована.
          </p>
          
          <div className={styles.heroStats}>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>24/7</span>
              <span className={styles.statLabel}>Поддержка</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>100%</span>
              <span className={styles.statLabel}>Подтверждение</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>1-2 ч</span>
              <span className={styles.statLabel}>Сроки</span>
            </div>
          </div>
          
          <div className={styles.heroButtons}>
            <a href="#contact" className="btn btn--primary">
              <i className="fas fa-receipt"></i>
              Заказать чек
            </a>
            <a href="#services" className="btn btn--secondary">
              <i className="fas fa-info-circle"></i>
              Подробнее об услугах
            </a>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Hero;